export default "<div class=\"tour-step-content\" [innerHTML]=\"content\"></div>\n"